module.exports = __webpack_public_path__ + "static/img/cutemobi-logo.4625cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cutemobi/imgs/cutemobi-logo.png
// module id = 2250
// module chunks = 0